(function (Drupal, once) {
  Drupal.behaviors.hslTabs = {
    attach(context) {
      // Prevent execution in non-browser environments
      if (typeof window === "undefined") {
        return;
      }

      // Ensure behavior runs only once per tabs container
      once("hsl-tabs", ".hsl-tabs__tabs-container", context).forEach(
        (tabsContainer) => {
          // Find the main tabs wrapper
          const tabsComponent = tabsContainer.closest(".hsl-tabs");
          if (!tabsComponent) return;

          // Get the tabs list element
          const tabsList = tabsContainer.querySelector(".hsl-tabs__tabs");
          if (!tabsList) return;

          // Get all tab items (li)
          const tabItems = tabsList.querySelectorAll("li");

          // Get all tab content panels
          const tabContents = tabsComponent.querySelectorAll(
            ".hsl-tabs__tab-content",
          );

          if (!tabItems.length || !tabContents.length) return;

          // -----------------------------------
          // Slug generator function
          // Removes accents, spaces and symbols
          // -----------------------------------
          function slugify(text) {
            return text
              .toString()
              .normalize("NFD") // separate accent from letters
              .replace(/[\u0300-\u036f]/g, "") // remove accents
              .toLowerCase()
              .trim()
              .replace(/\s+/g, "-") // replace spaces with dash
              .replace(/[^\w-]+/g, "") // remove special chars
              .replace(/--+/g, "-"); // avoid double dashes
          }

          // -----------------------------------
          // Automatically create data-href
          // based on tab label text
          // -----------------------------------
          tabItems.forEach((tabItem) => {
            const span = tabItem.querySelector("span");
            if (!span) return;

            const text = span.textContent.trim();
            if (!text) return;

            const slug = slugify(text);

            tabItem.setAttribute("data-href", slug);
          });

          // -----------------------------------
          // Activate tab by index
          // Optionally update URL hash
          // -----------------------------------
          function activateTab(index, updateHash = true) {
            // Remove active class from all tabs
            tabItems.forEach((item) => item.classList.remove("active"));

            // Remove active class from all content panels
            tabContents.forEach((content) =>
              content.classList.remove("active"),
            );

            // Activate selected tab
            if (tabItems[index]) {
              tabItems[index].classList.add("active");

              // Update URL hash without page reload
              if (updateHash) {
                const slug = tabItems[index].getAttribute("data-href");
                if (slug) {
                  history.replaceState(null, null, `#${slug}`);
                }
              }
            }

            // Activate corresponding content panel
            if (tabContents[index]) {
              tabContents[index].classList.add("active");
            }
          }

          // -----------------------------------
          // Handle click events
          // -----------------------------------
          tabItems.forEach((tabItem, index) => {
            tabItem.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              activateTab(index, true);
            });
          });

          // -----------------------------------
          // Open correct tab if URL contains hash
          // -----------------------------------
          const currentHash = window.location.hash.replace("#", "");

          if (currentHash) {
            let foundIndex = -1;

            tabItems.forEach((tabItem, index) => {
              const slug = tabItem.getAttribute("data-href");
              if (slug === currentHash) {
                foundIndex = index;
              }
            });

            if (foundIndex >= 0) {
              activateTab(foundIndex, false);
            } else {
              activateTab(0, false);
            }
          } else {
            // Default: activate first tab
            activateTab(0, false);
          }

          // -----------------------------------
          // Optional: listen to manual hash changes
          // (when user edits URL or uses back button)
          // -----------------------------------
          window.addEventListener("hashchange", () => {
            const newHash = window.location.hash.replace("#", "");

            tabItems.forEach((tabItem, index) => {
              if (tabItem.getAttribute("data-href") === newHash) {
                activateTab(index, false);
              }
            });
          });
        },
      );
    },
  };
})(Drupal, once);
